import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, retry} from 'rxjs/operators';
import {BaseNumberModel} from './base-number-model';
import {ApiUtils} from '../utils/api.utils';
import {ListFilter, ListResult, Pagination} from "@shared/base";
import {ConfigUtil} from '@shared/services/config.util';

export abstract class BaseNumberApi<M extends BaseNumberModel> {
  protected endpoint: string;

  protected constructor(
    protected httpClient: HttpClient,
    path: string
  ) {
    this.endpoint = `${ConfigUtil.get('api')['backend']}/${path}`;
  }

  abstract create(): M;

  public findAll(): Observable<M[]> {
    return this.httpClient.get<M[]>(this.endpoint);
  }

  public findByNumber(nr: number): Observable<M> {
    return this.httpClient.get<M>(`${this.endpoint}/${nr}`).pipe(map(value => {
      return Object.assign(this.create(), value);
    }));
  }

  public findByNumbers(nrs: string[]): Observable<M[]> {
    return this.httpClient.get<M[]>(`${this.endpoint}/by/number`, {
      params: {
        nr: nrs
      }
    });
  }

  public findByFilter(listFilter: ListFilter, pagination: Pagination): Observable<ListResult<M>> {
    const httpParams = ApiUtils.createHttpParams({...listFilter, ...pagination.toListFilter()});

    return this.httpClient.get<ListResult<M>>(`${this.endpoint}/search`, {params: httpParams}).pipe(map(value => {
      return Object.assign(new ListResult<M>(), value);
    }));
  }

  public save(model: M): Observable<M> {
    return this.httpClient.post<M>(`${this.endpoint}`, model).pipe(
      retry(0),
      map(value => {
        return Object.assign(this.create(), value);
      })
    );
  }

  public update(model: M): Observable<boolean> {
    return this.httpClient.put<boolean>(`${this.endpoint}/${model.number}`, model).pipe(
      retry(0)
    );
  }

  public delete(nr: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(`${this.endpoint}/${nr}`);
  }
}
